module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-bread-crumb', {
    attrs: {
      "bread-cumb": _vm.breadCrumb
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('glue-export-excel', {
    attrs: {
      "action": _vm.exportAction,
      "params": _vm.exportParams
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "用户名称",
      "prop": "nickname",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出生日期",
      "prop": "birth",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "prop": "mp",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "地址",
      "prop": "address",
      "width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "身份证号",
      "prop": "cert_no",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报名情况",
      "prop": "status",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签到情况",
      "prop": "sign_status",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评价",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.comment_time) ? _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.viewComment(row)
            }
          }
        }, [_vm._v("查看")]) : _c('div', [_vm._v("-")])]
      }
    }])
  })], 1), _vm._v(" "), _c('comment-detail', {
    ref: "commentDetailRef"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c878402"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/activity/joinDetail.vue
// module id = 899
// module chunks = 0